import Swiper from 'swiper'
import { A11y, EffectFade, Keyboard, Navigation, Thumbs, Pagination } from 'swiper/modules'

Swiper.use([A11y, Navigation, EffectFade, Keyboard, Thumbs, Pagination])

const initProductImageGalleries = () => {
    document.querySelectorAll('[data-main-image-slider]').forEach(mainSlider => {
        if (mainSlider.dataset.imageGalleryInitialized === 'true') return

        const slides = mainSlider.querySelectorAll('.swiper-slide')
        if (slides.length <= 1) return

        const gallery = mainSlider.closest('[data-product-image-gallery]') || mainSlider.parentElement?.parentElement || document
        const thumbSliderElement = gallery.querySelector('[data-thumb-images-slider]')
        const paginationElement = gallery.querySelector('.swiper-pagination')
        const nextButton = gallery.querySelector('.product-detail-images__nav--next')
        const prevButton = gallery.querySelector('.product-detail-images__nav--prev')

        mainSlider.dataset.imageGalleryInitialized = 'true'

        const thumbsSlider = thumbSliderElement ? new Swiper(thumbSliderElement, {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 20,
            watchOverflow: true,
            threshold: 10,
            pagination: paginationElement ? {
                el: paginationElement,
                clickable: true,
            } : undefined,
            breakpoints: {
                500: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            },
        }) : null

        const mainSwiper = new Swiper(mainSlider, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            thumbs: thumbsSlider ? {
                swiper: thumbsSlider,
            } : undefined,
            navigation: nextButton && prevButton ? {
                nextEl: nextButton,
                prevEl: prevButton,
            } : undefined,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            a11y: {
                enabled: true,
                nextSlideMessage: 'Next gallery item',
                prevSlideMessage: 'Previous gallery item',
                firstSlideMessage: 'This is the first gallery item',
                lastSlideMessage: 'This is the last gallery item',
            },
        })

        mainSwiper.on('slideChangeTransitionStart', () => {
            gallery.querySelectorAll('video').forEach(video => {
                video.pause()
            })
        })
    })
}

document.addEventListener('DOMContentLoaded', initProductImageGalleries)
document.addEventListener('htmx:afterSwap', initProductImageGalleries)
